(() => {
  if (customElements.get('sf-home-trust')) return;
  const BOOTSTRAP = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
  let bootstrapPromise;
  function getBootstrap() {
    if (window.Trustpilot?.loadFromElement) return Promise.resolve();
    if (bootstrapPromise) return bootstrapPromise;
    bootstrapPromise = new Promise((resolve, reject) => {
      let script = [...document.scripts].find(el => el.src.split('?')[0] === BOOTSTRAP);
      let created = false;
      if (!script) {
        script = document.createElement('script');
        script.src = BOOTSTRAP;
        script.async = true;
        created = true;
      }
      let attempts = 0;
      const check = () => {
        if (window.Trustpilot?.loadFromElement) { resolve(); return; }
        if (++attempts >= 40) { reject(new Error('Trustpilot unavailable')); return; }
        setTimeout(check, 250);
      };
      script.addEventListener('error', reject, { once: true });
      if (created) document.head.appendChild(script);
      check();
    }).catch(error => { bootstrapPromise = null; throw error; });
    return bootstrapPromise;
  }
  customElements.define('sf-home-trust', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      if (!('IntersectionObserver' in window)) { this.start(); return; }
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.observer.disconnect();
          this.start();
        }
      }, { rootMargin: '300px' });
      this.observer.observe(this);
    }
    async start() {
      if (this.started) return;
      this.started = true;
      const grid = this.querySelector('[data-sf-trust-grid]');
      if (!grid) return;
      try {
        await getBootstrap();
        if (!this.isConnected) { this.started = false; return; }
        this.classList.remove('sfht--unavailable');
        grid.classList.add('trustpilot-widget');
        if (!grid.querySelector('iframe')) window.Trustpilot.loadFromElement(grid, true);
      } catch (_) {
        this.started = false;
        this.classList.add('sfht--unavailable');
        // The visible direct Trustpilot link remains usable if a blocker prevents embedding.
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
})();
